






















import {Vue, Component, Prop} from 'vue-property-decorator';
import {ServiceDTO} from "@/components/payroll/business/services/ServiceDTO";
import PortalInput from "@/components/common/PortalInput.vue";

@Component({
	components: {PortalInput}
})
export default class ServiceView extends Vue {

	@Prop()
	private service!: ServiceDTO

	@Prop({default: true})
	private disablable!: boolean

	@Prop({default: true})
	private mutable!: boolean

	toEdit() {
		this.$emit("edit", this.service)
	}


	disable() {
		this.$emit("disable", this.service)
	}

}
